<template>
  <a-modal
    class="confirm-wrap"
    :visible="visible"
    :wrapClassName="!visible ? 'hide-modal' : ''"
    :width="dialogWidth"
    :closable="showClose"
    :centered="isNoFooter"
    :maskClosable="true"
    @cancel="cancelConfirm"
  >
    <template #closeIcon
    ><img style="width: 24px; height: 24px" :src="require('@/assets/common/close.png')"
    /></template>
    <template v-if="$slots['title']" #title>
      <slot name="title"></slot>
    </template>
    <template #footer>
      <slot name="footer">
        <div v-if="showLeftBtn || showRightBtn" class="confrim-footer flex f-jcc">
          <a-button v-if="showLeftBtn" class="cancel-btn" key="back" @click="onLeftBtnClick">
            {{ leftBtn }}
          </a-button>
          <a-button v-if="showRightBtn" class="ok-btn" key="submit" type="primary" @click="onRightBtnClick">
            {{ rightBtn }}
          </a-button>
        </div>
      </slot>
    </template>
    <div class="confirm-content" :class="isNoFooter?'confirm_content_self':''" :style="`width: ${contentWidth};`">
      <template v-if="!useHtml">
        <template v-if="$slots['icon']">
          <slot name="icon"></slot>
        </template>
        <img v-else-if="hideIcon === false" src="~@/assets/common/warning-outline.png"/>
        <div>{{ content }}</div>
      </template>
      <template v-else>
        <template v-if="$slots['content']">
          <slot name="content"></slot>
        </template>
        <div v-else :style="`text-align: ${contentAlign};`" v-html="content"></div>
      </template>
    </div>
  </a-modal>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'ConfirmDialog',
  props: {
    contentAlign: {
      type: String,
      default: 'center',
    },
    contentWidth: {
      type: String,
      default: '300px',
    },
    dialogWidth: {
      type: String,
      default: '400px',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    showLeftBtn: {
      type: Boolean,
      default: true,
    },
    leftBtn: {
      type: String,
      default: '取消',
    },
    showRightBtn: {
      type: Boolean,
      default: true,
    },
    isNoFooter: {
      type: Boolean,
      default: false,
    },
    rightBtn: {
      type: String,
      default: '确定放弃',
    },
    useHtml: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '你添加客户还未完成，确定放弃添加客户吗？',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    maskClosable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['left-btn-click', 'right-btn-click', 'cancelConfirm'],
  setup(props, {emit}) {
    const onLeftBtnClick = (e: any) => {
      emit('left-btn-click', e)
    }
    const onRightBtnClick = (e: any) => {
      emit('right-btn-click', e)
    }
    const cancelConfirm = () => {
      emit('cancelConfirm')
    }
    return {
      confirm,
      onLeftBtnClick,
      onRightBtnClick,
      cancelConfirm,
    }
  },
})
</script>

<style lang="scss" scoped>
.confirm-content {
  width: 300px;
  margin: 0 auto;
  text-align: center;

  &.confirm_content_self {
    width: unset;
  }

  img {
    width: 30px;
    height: 30px;
    margin: 10px 0 20px;
  }
}

.confrim-footer {
  margin-bottom: 30px;
  text-align: center;
}

.cancel-btn {
  min-width: 100px;
  color: #1e1e1e;
  border: 1px solid #aeaeae;
  border-radius: 4px;

  &:hover {
    color: #44b979;
    border: 1px solid #44b979;
  }
}

.ok-btn {
  min-width: 100px;
  margin-left: 20px;
  color: #fff;
}
</style>

<style lang="scss">
.confirm-wrap .ant-modal-footer {
  border-top: none;
}
</style>
